"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var componentName = 'wok-header';
exports.default = {
    name: componentName,
    functional: true,
    props: {
        title: {
            type: String,
            default: '*** Insert app title here ***'
        }
    },
    render: function (h, ctx) {
        return h('header', {
            class: ['wok--header__wrapper', ctx.data.staticClass],
            attrs: { role: 'banner' }
        }, [
            h('div', { class: 'wok--header' }, [
                h('wok-header-action', { props: { icon: 'wok-icon-menu-16' } }),
                h('div', { class: 'wok--header__content' }, [
                    h('h1', { class: 'wok--header__title wok--heading-06' }, [
                        ctx.props.title
                    ])
                ]),
                h('div', { class: 'wok--header__actions' }, [
                    ctx.slots().actions
                ])
            ])
        ]);
    }
};
